import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PedidoIntegracaoErpImportService {
    /** Evento executado após finalizar a importação dos pedidos do ERP */
    afterImport = new Subject<void>();

    /** Emite o evento de finalização da importação dos pedidos do ERP */
    emitAfterImport() {
        this.afterImport?.next();
    }
}
